<script setup>
const route = useRoute()

const props = defineProps({
  negMargin: {
    type: Boolean,
    default: () => true
  }
})
</script>
<template>
  <div class="w-full overflow-hidden">
    <ol 
      class="steps flex flex-col lg:flex-row py-12 justify-center md:items-start"
      :class="{'-ml-6' : negMargin && route.name !== 'index'}"
      >
      <slot />
    </ol>
  </div>
</template>
